import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PlanEenConsult() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="40083" id="uw-zorg-onze-passie" ref={ref} className="relative w-full overflow-hidden bg-primary py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden opacity-10">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576260/img/logo_watermark.png" alt="" className="h-[150%] w-auto max-w-none object-contain blur-sm grayscale brightness-200" />
      </div>

      {}
      <div className="container relative mx-auto px-4 text-center">
        <div className={`mx-auto max-w-4xl transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="font-serif text-4xl font-bold leading-tight text-primary-foreground md:text-5xl lg:text-7xl tracking-tight">
            Uw zorg, onze passie
          </h2>
          
          <div className="mt-10 flex justify-center">
            <Button asChild size="lg" className="h-14 bg-secondary px-10 text-lg font-semibold text-secondary-foreground shadow-2xl transition-all hover:scale-105 hover:bg-secondary/90 rounded-xl">
              <Link to="/ContactPage">
                Contact opnemen
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}